module.exports = __webpack_public_path__ + "fonts/Tox-Typewriter.324c78c.ttf";